// extracted by mini-css-extract-plugin
export const review = "homepage-review-module--review--wn00o";
export const byline = "homepage-review-module--byline--1Zpxg";